import React from "react";

const STEPS = [
  {
    n: "01", tag: "Detect",
    img: "https://images.unsplash.com/photo-1659938425098-6788938c89de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    title: "Smart cameras see it instantly",
    body: "AI-assisted cameras flag activity the moment someone steps onto your property — gates, lobbies, corridors, garages, mailrooms and amenities. The footage streams straight to our command center.",
  },
  {
    n: "02", tag: "Engage",
    img: "https://static.prod-images.emergentagent.com/jobs/d6d19dde-3ac3-43df-a169-28a9d2505ed7/images/02b2bfbd575855a7fba64d15d72a1319c17445cf618b7bf2722320f5a390e3cc.png",
    title: "A live guard steps in",
    body: "A dedicated virtual guard verifies the situation and intervenes in real time — a calm voice-down over two-way audio, a deterrent alarm, or a simple welcome for a resident they recognize.",
  },
  {
    n: "03", tag: "Respond",
    img: "https://images.unsplash.com/photo-1646991761123-d83ce47c30c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    title: "Verified response in seconds",
    body: "If it's a genuine threat, we escalate to authorities immediately — with verified, eyes-on context. That means faster police response and virtually no false alarms for your board to manage.",
  },
];

const HowItWorks3 = () => (
  <section id="how" className="bg-white py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6">
      <div data-reveal className="text-center max-w-2xl mx-auto mb-16">
        <div className="inline-flex items-center gap-2 mb-5 text-xs font-semibold uppercase tracking-[0.2em] text-[#D32F2F]">
          <span className="w-1.5 h-1.5 rounded-full bg-[#D32F2F] pulse-dot" /> How It Works
        </div>
        <h2 className="font-head text-4xl sm:text-5xl font-semibold tracking-tight text-[#0F172A] leading-[1.05]">
          See it. Engage it. Stop it.
        </h2>
        <p className="text-[#0F172A]/55 mt-5 text-lg">
          Three steps, in real time — the difference between preventing an incident and just recording one.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-7">
        {STEPS.map((s, i) => (
          <div key={s.n} data-reveal data-reveal-delay={i + 1}
               className="rounded-2xl overflow-hidden bg-white border border-[#0F172A]/[0.08] shadow-[0_18px_50px_-24px_rgba(15,23,42,0.25)]">
            <div className="relative h-52 overflow-hidden">
              <img src={s.img} alt={s.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent" />
              <span className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full bg-white/90 backdrop-blur px-3 py-1.5">
                <span className="font-head text-sm font-bold text-[#D32F2F]">{s.n}</span>
                <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#0F172A]">{s.tag}</span>
              </span>
            </div>
            <div className="p-7">
              <h3 className="font-head text-xl font-semibold text-[#0F172A] mb-3 leading-snug">{s.title}</h3>
              <p className="text-[15px] text-[#0F172A]/60 leading-relaxed">{s.body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks3;
